import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { getDateMMDDYYYY } from '_helpers';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';
import { DBDateField, CancelButton, DBDropDown, DBTextField, CopyButton } from '_components';

class PatientCareCenterNoteGoalsGoalShortTermGoalDetailCustom extends React.Component {

    deleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTSHORTGOALS', 'SGNO', this.props.id, 'SGACTIVE', false);
    }

    copyProgress() {
        this.props.updateIntField(this.props.noteId, 'PTSHORTGOALS', 'SGNO', this.props.shortGoal.SGNO, 'SGGPNO', this.props.shortGoal.SGGPNOPREV);
    }

    render() {

        return (
            <PatientCareCenterNoteNavAnchor id={'sgno_' + this.props.shortGoal.SGNO} >
                <div className={styles.stg_detail_wrapper}>
                    <div className={styles.stg_detail_row}>

                        <div className={styles.goal_detail_col1}>
                            {(this.props.noteType === 1 || !this.props.prevGoal || this.props.isSpeech || this.props.isPeds) &&
                                <CancelButton title='Delete Goal' size='extra-small' onClick={() => this.deleteGoal()} />
                            }
                        </div>


                        <div className={styles.stg_desc_custom}>
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTSHORTGOALS'
                                entityKeyColumn='SGNO'
                                entityKeyValue={this.props.shortGoal.SGNO}
                                field='SGDESC'
                                className={this.props.reqDesc ? styles.text_field_req : styles.text_field}
                                placeholder='Describe or quantify goal'
                                disabled={this.props.prevGoal}
                            />
                        </div>
                        <div className={styles.stg_date}>
                            <span className={styles.date_field}>
                                <DBDateField
                                    noteId={this.props.noteId}
                                    entity='PTSHORTGOALS'
                                    entityKeyColumn='SGNO'
                                    entityKeyValue={this.props.shortGoal.SGNO}
                                    maxDate={new Date().setFullYear(new Date().getFullYear() + 1)}
                                    field='SGDATE'
                                    disabled={this.props.noteType === 2}
                                    customMsg='The goal date cannot be in the past.'
                                    minDate={getDateMMDDYYYY(new Date())}
                                    required={this.props.reqDate}
                                />
                            </span>
                        </div>

                        {this.props.noteType !== 1 &&
                            <>
                                <span className={styles.goal_detail_prog_dropdown_stg}>
                                    <DBDropDown
                                        className={this.props.reqProgress ? styles.goal_level_dropdown_req : styles.goal_level_dropdown}
                                        noteId={this.props.noteId}
                                        entity='PTSHORTGOALS'
                                        entityKeyColumn='SGNO'
                                        entityKeyValue={this.props.shortGoal.SGNO}
                                        field='SGGPNO'
                                        masterEntity='PTMASTERGOALPROGRESS'
                                        masterEntityKeyColumn='GPNO'
                                        masterEntitySort='GPORDER'
                                        masterEntityDisplay='GPNAME'

                                    />
                                </span>
                                {(this.props.noteType === 3 || this.props.noteType === 5) &&
                                    <div className={styles.goal_detail_copy_col}>
                                        <CopyButton size='extra-small' title='Copy value from most recent note' onClick={() => this.copyProgress()} />
                                    </div>
                                }

                            </>
                        }
                    </div>
                </div>
            </PatientCareCenterNoteNavAnchor>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let description = ownprops.label;
    let days = ownprops.defaultDays;
    let shortGoal = state.entities.notes.PTSHORTGOALS[ownprops.id];

    let prevGoal = false;
    if (shortGoal.SGSGNO) {
        prevGoal = true;
    }


    let reqDesc = false;
    let reqDate = false;
    let reqProgress = false;

    if (shortGoal.SGACTIVE && !shortGoal.SGDESC) {
        reqDesc = true;
    }
    if (shortGoal.SGACTIVE && !shortGoal.SGDATE) {
        reqDate = true;
    }
    if (shortGoal.SGACTIVE && !shortGoal.SGGPNO) {
        reqProgress = true;
    }

    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" && isSpeechEnabled ? true : false;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled ? true : false;

    return {
        noteId,
        noteType,
        pk,
        goal,
        description,
        days,
        shortGoal,
        reqDesc,
        reqDate,
        reqProgress,
        prevGoal,
        isSpeech,
        isPeds
    };
}

const connectedPatientCareCenterNoteGoalsGoalShortTermGoalDetailCustom = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalShortTermGoalDetailCustom);
export { connectedPatientCareCenterNoteGoalsGoalShortTermGoalDetailCustom as PatientCareCenterNoteGoalsGoalShortTermGoalDetailCustom };

